import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";
import Link from "@mui/material/Link";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

import CategoriesList from "cxfcomponents/Lists/CategoriesList";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ThemedRocketLaunchIcon } from "assets/CXFIcons/Portal/Dashboard";
import { ThemedFileLines } from "assets/CXFIcons/Portal/Dashboard";

const bgColor = "linear-gradient(to right, #7443FF , #62D9FF)";

const BottomAction = () => {
  const { t } = useTranslation("dashboard");
  return (
    <SoftBox>
      <SoftButton
        sx={{ float: "right" }}
        component={Link}
        href="https://cxfabric.io/docs/#/introduction/what-is-cxfabric"
        target="_blank"
        rel="noreferrer"
        variant="text"
        color="primary"
      >
        {t("buttons.view_all")} <ArrowForwardIcon sx={{ marginLeft: "12px" }} />
      </SoftButton>
    </SoftBox>
  );
};

const GetStarted = () => {
  const { t } = useTranslation("dashboard");

  const categories = [
    {
      color: bgColor,
      icon: <ThemedFileLines width={20} height={20} color="white" />,
      name: (
        <Link
          href="https://cxfabric.io/docs/#/build/flows/create-flow"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          {t("labels.how_to_create_flow")}
        </Link>
      ),
      //description: "Learn the process of creating workflows",
      description: (
        <Link
          href="https://cxfabric.io/docs/#/build/flows/create-flow"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          Learn the process of creating workflows
        </Link>
      )
    },
    {
      color: bgColor,
      icon: <ThemedFileLines width={20} height={20} color="white" />,
      name: (
        <Link
          href="https://cxfabric.io/docs/#/build/connectors/create-a-connector"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          {t("labels.how_to_register_a_component")}
        </Link>
      ),
      //description: "Learn the process of registering components",
      description: (
        <Link
          href="https://cxfabric.io/docs/#/build/connectors/create-a-connector"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          Learn the process of registering components
        </Link>
      )
    },
    {
      color: bgColor,
      icon: <ThemedFileLines width={20} height={20} color="white" />,
      name: (
        <Link
          href="https://cxfabric.io/docs/#/developer-tools/overview"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          {t("labels.api_documentation")}
        </Link>
      ),
      description: (
        <Link
          href="https://cxfabric.io/docs/#/developer-tools/overview"
          target="_blank"
          rel="noreferrer"
          underline="hover"
          color="inherit"
        >
          Development guide for API integration
        </Link>
      )
    }
  ];

  return (
    <CategoriesList
      title={t("labels.get_started")}
      categories={categories}
      isExternal
      headerIcon={<ThemedRocketLaunchIcon />}
      bottomAction={<BottomAction />}
    />
  );
};

export default GetStarted;
